var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.019,
    height: 24,
    viewBox: "0 0 24.019 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(0 -0.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M9.837,19.725A9.8,9.8,0,0,0,15.3,18.066l5.652,5.652a1.176,1.176,0,0,0,1.64,0l1.1-1.1a1.176,1.176,0,0,0,0-1.64l-5.671-5.632a9.834,9.834,0,1,0-8.178,4.379Zm0-15.817a5.98,5.98,0,1,1-5.98,5.98A5.985,5.985,0,0,1,9.837,3.908Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ee110c7e99a718a831a2dd8f605ce89f.svg";
export { ForwardRef as ReactComponent };